import FJTextarea from '../../../common/components/FJTextarea/FJTextarea';
import styles from './FJPromptInput.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJAddIcon from '../../../assets/svg/add.svg?react';
import FJZoomIcon from '../../../assets/svg/timeline-zoom-.svg?react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { useState } from 'react';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip';
const FJPromptInput = props => {
    const { prompt, changePrompt, isOpenPromptInput, changeOpenPromptInput } = props;

    // const [isFocused, setIsFocused] = useState(false);

    const _onchangePrompt = e => {
        changePrompt(e.target.value);
    };

    return (
        <div
            className={classNames(styles.box, {
                [styles.open]: isOpenPromptInput,
                [styles.focused]: isOpenPromptInput,
            })}
        >
            <div className={styles.header_box}>
                {FJLocalStore._('prompt')}
                <FJToolTip title={FJLocalStore._(isOpenPromptInput ? 'fold' : 'unfold')}>
                    <div>
                        {isOpenPromptInput ? (
                            <FJZoomIcon className={styles.zoom_icon} onClick={changeOpenPromptInput} />
                        ) : (
                            <FJAddIcon className={styles.add_icon} onClick={changeOpenPromptInput} />
                        )}
                    </div>
                </FJToolTip>
            </div>

            <FJTextarea
                className={styles.textarea}
                text={prompt}
                placeholder={FJLocalStore._('describe-the-image-briefly-to-get-more-accurate-results')}
                onChange={_onchangePrompt}
                maxLength={200}
                // changeIsFocused={setIsFocused}
            />
        </div>
    );
};
FJPromptInput.propTypes = {
    prompt: PropTypes.string,
    changePrompt: PropTypes.func,
    isOpenPromptInput: PropTypes.bool,
    changeOpenPromptInput: PropTypes.func,
};

export default FJPromptInput;
